import _ from "lodash";
import { DashboardStyled } from "../Dashboard-styles";
import { useEffect, useState } from "react";
import {
  AIRFLOW,
  FieldBirthDate,
  FieldGender,
  FieldRace,
  FieldRace_Other,
  LIGHTING,
  OTHER_STR,
  RaceOptions,
  TEMPERATURE,
  THERMAL_VOTE
} from "../Dashboard-const";
import { staffServ } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { API_CODE, TARGET } from "../../../common/utils/const";
import { layoutActions } from "../../../store/actions";
import { useForm } from "react-hook-form";
import { AppButton, AppForm } from "../../../components";
import { toast } from "react-toastify";
import { MOMENT_FORMAT, formatDate } from "../../../common/utils/date";
import SearchIcon from '@mui/icons-material/Search';
import { getLocalstorage } from "../../../common/utils/other";
import {isMobile} from 'react-device-detect';

export default function PPRS() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const toggleLoadingMain = () => {
    dispatch(layoutActions.toggleLoadingMain());
  };
  const [staff, setStaff] = useState({
    user_id: auth.user.profile.user_id,
    temperature: "1",
    airflow: "1",
    illuminance: "1",
    priority: 1,
  });
  const {
    reset,
    setError,
    clearErrors,
    getValues,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const tab = {
    ThermalVote: 'ThermalVote',
    Preferences: 'Preferences',
    Profile: 'Profile',
    Colleague_Finder: 'Colleague_Finder'
  }
  const [mode, setMode] = useState(tab.ThermalVote);
  const source = getLocalstorage(TARGET);

  useEffect(() => {
    const init = async () => {
      reset({
        birthDate: new Date(),
        race_options: RaceOptions,
      });

      await getStaffDetail();
    };
    init();
  }, []);

  const getStaffDetail = async () => {
    toggleLoadingMain();
    try {
      const params = {
        userId: auth.user.profile.user_id,
      };
      const { data, errMsg, errCode } = await staffServ.getStaffDetail(params);

      if (!_.isEmpty(data) && errCode == API_CODE.SUCCESS) {
        setStaff(data);

        if (data?.profile) {
          const profile = JSON.parse(data?.profile);
          setValue("birthDate", profile.birthdate);
          setValue("gender", profile.gender);

          let race = profile.race;
          if (profile.race.includes(OTHER_STR)) {
            const raceSplit = race.split('-');
            race = raceSplit[0];
            setValue("other", raceSplit[1]);
          }
          setValue("race", race);
        }
      }
    } catch (error) { }

    toggleLoadingMain();
  };

  const updateStaff = async (obj) => {
    try {
      const params = {
        ...staff,
        updated_by: auth.user.profile.mail,
        ...obj,
      };

      setStaff(_.cloneDeep(params));
      const { data, errMsg, errCode } = await staffServ.updateStaff(params);

      if (errCode != API_CODE.SUCCESS) {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveProfile = async () => {
    const values = getValues();
    let race = values?.race || "";

    if (race == -1) {
      toast.warning('Please select Race');
      return;
    }

    if (race == OTHER_STR) {
      if (values.other == '') {
        toast.warning('Please input Other');
        return;
      } else {
        race = `${OTHER_STR}-${values.other}`
      }
    }

    if (values.birthDate === '') {
      toast.warning('Please select BirthDate');
      return;
    }

    const profile = {
      birthdate: formatDate(values?.birthDate, MOMENT_FORMAT.YYYY_MM_DD) || "",
      gender: values?.gender || "male",
      race: race
    };

    try {
      const params = {
        ...staff,
        profile: JSON.stringify(profile),
        updated_by: auth.user.profile.mail
      };

      const { errCode } = await staffServ.updateStaff(params);

      if (errCode == API_CODE.SUCCESS) {
        toast.success("Save profile success");
      }
    } catch (error) {
      console.log(error);
      toast.success("Save profile failed");
    }
  };

  const renderMenu = (className) => {
    return (
      <div className={className}>
        <div
          className={`normal ${mode == tab.ThermalVote ? "active" : ""}`}
          onClick={() => setMode(tab.ThermalVote)}
        >
          <div style={{ textAlign: "center", marginTop: 2 }} >
            <img src="images/TEMP/TEMP3.svg" width="20px" height="20px" style={{ WebkitFilter: 'brightness(0) invert(1)'}} />
          </div>
          <div style={{ textAlign: "center" }} >
            <span style={{ fontSize: "14px" }}>Thermal Vote</span>
          </div>
        </div>
        <div
          className={`normal ${mode == tab.Preferences ? "active" : ""}`}
          onClick={() => setMode(tab.Preferences)}
        >
          <div style={{ textAlign: "center", marginTop: 2 }} >
            <img src="preferences.svg" width="20px" height="20px" />
          </div>
          <div style={{ textAlign: "center" }} >
            <span style={{ fontSize: "14px" }}>Preferences</span>
          </div>
        </div>
        <div
          className={`normal ${mode == tab.Profile ? "active" : ""}`}
          onClick={() => setMode(tab.Profile)}
        >
          <div style={{ textAlign: "center", marginTop: 2 }} >
            <img src="profile.svg" width="20px" height="20px" />
          </div>
          <div style={{ textAlign: "center" }} >
            <span style={{ fontSize: "14px" }}>Profile</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ width: '100%'}}>
      {
        isMobile && 
        <div className="block-tab">
          {renderMenu('tab')}
        </div>
      }

      {
        !isMobile &&
        <div className="menu-left">
          {renderMenu('tab-desktop')}
        </div>
      }

      <div className={isMobile ? 'main' : 'main-desktop'}>
        {mode == tab.ThermalVote && (
          <div className="setting">
            {/* Thermal sensation vote */}
            <div className="title">THERMAL SENSATION VOTE</div>
            <div className="temperature-area">
              {THERMAL_VOTE.map((x, i) => {
                return (
                  <div key={i} className="item">
                    <button
                      className={
                        staff?.thermalSensation == x.value ? "active" : "inactive"
                      }
                      onClick={() => updateStaff({ thermalSensation: x.value })}
                    >
                      <div className="icon-button">
                        <img alt="" src={x.icon} width="25" height="25"></img>
                      </div>
                      <div>
                        <span>{x.label}</span>
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {mode == tab.Preferences && (
          <div className="setting">
            {/* Temperature */}
            <div className="title">TEMPERATURE</div>
            <div className="temperature-area">
              {TEMPERATURE.map((x, i) => {
                return (
                  <div key={i} className="item">
                    <button
                      className={
                        staff?.temperature == x.value ? "active" : "inactive"
                      }
                      onClick={() => updateStaff({ temperature: x.value })}
                    >
                      <div className="icon-button">
                        <img alt="" src={x.icon} width="25" height="25"></img>
                      </div>
                      <div>
                        <span>{x.label}</span>
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
            {/* Lighting */}
            <div className="title">LIGHTING</div>
            <div style={{ overflow: "auto" }} className="temperature-area">
              {LIGHTING.map((x, i) => {
                return (
                  <div key={i} className="item">
                    <button
                      className={
                        staff?.illuminance == x.value ? "active" : "inactive"
                      }
                      onClick={() => updateStaff({ illuminance: x.value })}
                    >
                      <div className="icon-button">
                        <img alt="" src={x.icon} width="25" height="25"></img>
                      </div>
                      <div>
                        {x.label}
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Airflow */}
            <div className="title">AIRFLOW</div>
            <div style={{ overflow: "auto" }} className="temperature-area">
              {AIRFLOW.map((x, i) => {
                return (
                  <div key={i} className="item">
                    <button
                      className={staff?.airflow == x.value ? "active" : "inactive"}
                      onClick={() => updateStaff({ airflow: x.value })}
                    >
                      <div className="icon-button">
                        <img alt="" src={x.icon} width="25" height="25"></img>
                      </div>
                      <div>
                        {x.label}
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {mode == tab.Profile && (
          <div className="profile">
            <div className="content">
              <div className="gender row">
                <span className="title">GENDER</span>
                <AppForm
                  className="text__gender"
                  fields={FieldGender}
                  control={control}
                  size="small"
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                />
              </div>
              <div className="birth-date row">
                <span className="title">BIRTH DATE</span>
                <AppForm
                  className="text__birth_date"
                  fields={FieldBirthDate}
                  control={control}
                  size="small"
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                />
              </div>
              <div className="race row">
                <span className="title">RACE</span>
                <AppForm
                  className="text__birth_race"
                  fields={FieldRace}
                  control={control}
                  size="small"
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                />
                {
                  watch('race') == OTHER_STR &&
                  <div style={{ marginTop: '15px' }}>
                    <span className="title">PLEASE SPECIFY</span>
                    <AppForm
                      className="text__birth_race"
                      fields={FieldRace_Other}
                      control={control}
                      size="small"
                      errors={errors}
                      getValues={getValues}
                      setValue={setValue}
                    />
                  </div>
                }

                {/* <AppMultipleSelect
                value={raceValue}
                setValue={setRaceValue}
                items={RaceOptions}
                label="Select"
              /> */}
              </div>
            </div>
            <div className="footer">
              <AppButton
                style={{ width: "100%", height: 50, background: "#EE602C" }}
                label="Save"
                onClick={saveProfile}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
